import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { IconButton, Typography, useMediaQuery } from '@mui/material';

import Box from '@mui/material/Box';
import React from 'react';
import shield from '../../assets/shield.png';
import { useSwipeable } from 'react-swipeable';

interface ClanSliderProps {
  clans: {
    id: string;
    coverImage: string;
    title: string;
  }[];
  activeSlide: number;
  setActiveSlide: (index: number) => void;
  next: () => void;
  prev: () => void;
  slideWidth: number;
  slideHeight: number;
  handleClansSlide: any;
  handleClanDetail: any;
}

const ClanSlider: React.FC<ClanSliderProps> = ({
  clans,
  activeSlide,
  setActiveSlide,
  next,
  prev,
  slideWidth,
  slideHeight,
  handleClansSlide,
  handleClanDetail
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const handlers = useSwipeable({
    onSwipedLeft: () => next(),
    onSwipedRight: () => prev(),
    delta: 10,
    preventScrollOnSwipe: true,
    trackMouse: true
  });

  const getStyles = (index: number) => {
    const screenWidth = window.innerWidth;
    const baseTranslateX = isMobile ? screenWidth * 0.15 : screenWidth * 0.17;
    const baseTranslateZ = isMobile ? screenWidth * 0.5 : screenWidth * 0.2;

    if (activeSlide === index) {
      return {
        opacity: 1,
        transform: 'translateX(0px) translateZ(0px) rotateY(0deg)',
        zIndex: 10
      };
    } else if (activeSlide - 1 === index) {
      return {
        opacity: 1,
        transform: `translateX(-${baseTranslateX}px) translateZ(-${baseTranslateZ}px) rotateY(35deg)`,
        zIndex: 9
      };
    } else if (activeSlide + 1 === index) {
      return {
        opacity: 1,
        transform: `translateX(${baseTranslateX}px) translateZ(-${baseTranslateZ}px) rotateY(-35deg)`,
        zIndex: 9
      };
    } else if (activeSlide - 2 === index) {
      return {
        opacity: 1,
        transform: `translateX(-${2 * baseTranslateX}px) translateZ(-${baseTranslateZ + 100}px) rotateY(35deg)`,
        zIndex: 8
      };
    } else if (activeSlide + 2 === index) {
      return {
        opacity: 1,
        transform: `translateX(${2 * baseTranslateX}px) translateZ(-${baseTranslateZ + 100}px) rotateY(-35deg)`,
        zIndex: 8
      };
    } else if (index < activeSlide - 2) {
      return {
        opacity: 0,
        transform: `translateX(-${2 * baseTranslateX}px) translateZ(-${baseTranslateZ + 100}px) rotateY(35deg)`,
        zIndex: 7
      };
    } else if (index > activeSlide + 2) {
      return {
        opacity: 0,
        transform: `translateX(${2 * baseTranslateX}px) translateZ(-${baseTranslateZ + 100}px) rotateY(-35deg)`,
        zIndex: 7
      };
    }
  };

  console.log('clanSlider--0', clans);

  return (
    <Box sx={{ width: '100%', maxWidth: '80%', paddingBottom: '20px' }}>
      <div className="slideC" {...handlers} style={{ width: slideWidth, height: slideHeight }}>
        {clans.map((item, i) => (
          <div
            key={item.id}
            className="slide"
            role="button"
            tabIndex={0}
            style={{
              cursor: 'pointer',
              position: 'absolute',
              width: slideWidth,
              height: slideHeight,
              transition: 'transform 0.5s ease, opacity 0.5s ease',
              ...getStyles(i)
            }}
            onClick={() => {
              handleClansSlide(i);
              handleClanDetail(i, item);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setActiveSlide(i);
              }
            }}>
            <img
              src={item.coverImage}
              alt="Shield"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
              className="slide-img"
            />
          </div>
        ))}
      </div>

      <Typography
        color="white"
        align="center"
        style={{ padding: '20px', fontSize: '13px', fontFamily: 'Baloo2', fontWeight: '700' }}>
        {clans[activeSlide]?.title}
      </Typography>
    </Box>
  );
};

export default ClanSlider;
